import { render } from "./contact.vue?vue&type=template&id=7f2cce41&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=7f2cce41&lang=scss&scoped=true"

import exportComponent from "F:\\Code3\\hwh-website\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7f2cce41"]])

export default __exports__